export default "__VITE_ASSET__514e554c__"